import { Suspense, lazy, useEffect, useState } from "react";
import { PlusButton, ActionButton } from "../../helper/ImageFormat";
import Breadcrumb from "../../helper/Breadcrumb";
import Spinner from "../../Components/spinner";
import { deleteItem, submitForm } from "../../utils/apiUtils";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import { useNavigate } from "react-router-dom";
import dateformate from "../../helper/DateFormate";
const DeleteModal = lazy(() => import("../../Components/DeleteModel"));
const RoleModal = lazy(() => import("../../Model/Model").then(mod => ({ default: mod.RoleModal })));

const Role = () => {
   const navigator = useNavigate();
  const [loading, setLoading] = useState(false);
  const [roleData, setroleData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "" });
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const fetchData = async () => {
    await fetchAllData("role", setroleData, null, setLoading);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const target = roleData.find((item) => item.id === editingId);
    setFormData(target ? { name: target.name } : { name: "" });
  }, [editingId, roleData]);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setEditingId(null);
    setFormData({ name: "" });
    setErrors({});
  };

  const handleChange = ({ target: { name, value } }) => {
    if (Number(value) < 0) {
      setErrors((prev) => ({ ...prev, [name]: "Negative values are not allowed" }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    if (!formData.name) {
    setErrors({ name: "role is required" });
    setBtnLoading(false);
    return;
  }
    setBtnLoading(true);
    try {
      await submitForm({
        data: formData,
        url: "/role",
        editingId,
        validateFields: [],
        validationErrorsSetter: setErrors,
        onSuccess: fetchData,
        closeModal: () => setModalOpen(false),
      });
    } finally {
      setBtnLoading(false);
    }
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("role", deleteItemId, fetchData);
      setDeleteItemId(null);
      setDeleteModalOpen(false);
      return res;

    } catch (error) {
      return error;

    } finally {
      setIsDeleting(false);
    }
  };

  const breadcrumbData = [
    { label: "Home", path: "/" },
    { label: "Roles", path: "*" },
  ];

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="custom-page-title">Roles</h3>
        <Breadcrumb items={breadcrumbData} />
      </div>

      <div className="d-flex justify-content-end bg-white p-2 mt-n2" style={{ gap: "10px" }}>
        <PlusButton handleAdd={toggleModal} module={"Roles"} />
      </div>

      <div className="row mt-2">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="custom-table table table-striped">
                  <thead>
                    <tr style={{ marginTop: "10px", border: "2px solid #fff" }}>
                      <th>
                      </th>
                      <th>Role</th>
                      <th>Permissions</th>
                      <th>Updated At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          <Spinner />
                        </td>
                      </tr>
                    ) : roleData.length > 0 ? (
                      roleData.map((item, index) => (
                        <tr key={item.id}>
                          <td>
                          </td>
                          <td>{item.name}</td>
                           <td ><button
  type="button"
  className="count-button1 flex items-center gap-2"
  onClick={() => navigator("/permission", { state: item.id })}
>
  <i className="fa-solid fa-sitemap"></i>
  <span>{item._count?.children}</span>
</button>

                                          </td>
                                          <td>{dateformate(item.updatedAt)}</td>
                                          {/* <td>{dateformate(item.createdAt)}</td> */}
                          <td className="text-left col-4">
                            <Suspense fallback={<span>...</span>}>
                              <ActionButton
                                data={item}
                                module={"Roles"}
                                handleEditClick={() => {
                                  setEditingId(item.id);
                                  setModalOpen(true);
                                }}
                                handleDelete={() => {
                                  setDeleteItemId(item.id);
                                  setDeleteModalOpen(true);
                                }}
                              />
                            </Suspense>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          <h5>No data found.</h5>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={null}>
        {modalOpen && (
          <RoleModal
            isOpen={modalOpen}
            toggle={toggleModal}
            editingId={editingId}
            data={formData}
            errors={errors}
            loading={btnLoading}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        )}
      </Suspense>

      <Suspense fallback={null}>
        {deleteModalOpen && (
          <DeleteModal
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(false)}
            onConfirm={confirmDelete}
            itemName="Role"
            isDeleting={isDeleting}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Role;